import React, { useMemo } from 'react';
import find from 'lodash/find';

import endpointsResource from 'src/actions/endpoints/endpointsResource';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { getAgentDesktopURL } from 'src/presentation/components/pages/shared/utils/Utils';
import KeyValueReadOnlyFields from 'src/presentation/components/pages/proactiveCommunications/components/KeyValueReadOnlyFields';
import useCurrentAnswer from 'src/presentation/components/pages/shared/hooks/useCurrentAnswer';
import { useResourceAll } from 'src/presentation/hooks/useResource';

const VoiceCampaignContentDetails = ({ campaign }) => {
  const { values: endpoints = [] } = useResourceAll(endpointsResource);

  const endpoint = useMemo(
    () => find(endpoints, endpoint => endpoint.id === campaign.content?.endpointId),
    [campaign, endpoints]
  );

  const { value: answer } = useCurrentAnswer(campaign.content?.answerId);

  const renderAnswer = answer && (
    <ExternalLink
      data-aid="navigate-to-answer"
      label={answer?.name || answer?.id || ''}
      to={getAgentDesktopURL(`kb-admin/answer/${answer.id}`)}
    />
  );

  return (
    <KeyValueReadOnlyFields
      fields={{
        'Phone Number': endpoint?.address || '',
        Language: campaign.content.answerLanguage,
        Answer: renderAnswer,
      }}
    />
  );
};

export default VoiceCampaignContentDetails;
